import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-separator',
  templateUrl: './separator.component.html'
})
export class SeparatorComponent implements OnInit {

  @Input() top = '10';
  @Input() bottom = '10';
  @Input() adaptWidth = false;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/enzo/Desktop/capsycofr-angular/src/app/components/separator/separator.component.ts